<mat-card>
  <app-headline>
    <h1 app-headline-title
        color="primary">Jigs</h1>
    <app-headline-actions align="left">
      <button mat-icon-button
              (click)="openForm()">
        <mat-icon>add</mat-icon>
      </button>
    </app-headline-actions>
  </app-headline>

  <ngrx-busy>
    <div class="overflow-content" role="region" aria-label="Jigs table" tabindex="0">
      <mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="id">
          <mat-header-cell
            *matHeaderCellDef>Id
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row">
            <app-code>{{row.id}}</app-code>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="short_id">
          <mat-header-cell
            *matHeaderCellDef>Short Id
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row">{{row.short_id}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="settings">
          <mat-header-cell
            *matHeaderCellDef>Settings
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row">{{row.settings}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="options">
          <mat-header-cell
            *matHeaderCellDef>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row">
            <button mat-icon-button
                    (click)="openForm(row)">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="['id', 'short_id', 'settings', 'options']"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: ['id', 'short_id', 'settings', 'options']"></mat-row>
      </mat-table>
    </div>
  </ngrx-busy>
</mat-card>
